// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610142335/js/" + chunkId + "." + {"44":"da4ea9ed","225":"7b4de3da","481":"7b254dbd","486":"fc2d45fe","770":"9ce48e70"}[chunkId] + ".0.1951799048502313.chunk.js";
};